import { NodeTypeKeys } from '../../utils/NodeTypeKeys';
import { Position } from '../../types';
import { Leaf } from '../Leaf';

export class EndOfFlowNode extends Leaf {
  public constructor(id: string, position: Position = undefined, isHidden: boolean = undefined) {
    super(id, NodeTypeKeys.endOfFlowNodeType, [], { position, isHidden });
  }
}
